import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {capitalize} from 'lodash';

import {renderMoment} from 'lib/timeUtils';
import {MandarkTable, Icon, Button, Heading} from '@albert-io/atomic';
import {Link} from 'react-router';
import {
  getNonPendingSearchFilters,
  getApprovedStaff,
  rejectUser
} from 'client/SchoolAdministration/School/ManageStaff/Staff/manageStaffUtils';

import RejectUserModal from './RejectUserModal.react';

const Approved = ({params}) => {
  const [staffMemberToReject, setStaffMemberToReject] = useState(null);
  return (
    <div className='u-mar-t_4'>
      <MandarkTable
        query={getApprovedStaff(params.schoolId)}
        searchFilters={getNonPendingSearchFilters}
        searchPlaceholder='Search'
        title='Staff Members'
        defaultSortDirection='ASCENDING'
        persistSearch
        persistPage
        customEmptyTable={
          <div className='u-text-align_center'>
            <Heading size='s' className='u-mar-t_4'>
              No Approved Staff Members
            </Heading>
          </div>
        }
        buttonGroup={[
          <Button as={Link} to={`/school-admin/${params.schoolId}/update-teachers`}>
            <Icon icon={['far', 'user-plus']} className='u-mar-r_1' />
            Update Teacher List
          </Button>
        ]}
      >
        <MandarkTable.Column
          defaultSortParam
          heading='Email'
          content={(staff) => {
            if (staff.has('teacher') && staff.getTeacher().size === 0) {
              return (
                <div className='manage-staff__personnel-invitation-name'>Email not available</div>
              );
            }
            if (!staff.has('teacher')) {
              return staff.getEmail();
            }
            return staff.getTeacher().getEmail();
          }}
          className='u-word-break_break-all'
          sortBy='teacher_v1.email'
        />
        <MandarkTable.Column
          heading='Name'
          className='manage-staff__name'
          content={(staff) => {
            const sentDate =
              !staff.has('teacher') && staff.getSentEmailAt()
                ? `Last sent ${renderMoment(staff.getSentEmailAt())}`
                : 'Queued for delivery';

            if (staff.has('teacher') && staff.getTeacher().size === 0) {
              return (
                <div className='manage-staff__personnel-invitation-name'>
                  This user has switched their account type to student.
                </div>
              );
            }
            if (!staff.has('teacher')) {
              return (
                <div className='manage-staff__personnel-invitation-name'>
                  The owner of this email hasn&apos;t created an account yet.
                  <span className='manage-staff__personnel-invitation-date-sent'>{sentDate}</span>
                </div>
              );
            }
            return staff.getTeacher().getFullName({formal: true});
          }}
          sortBy='teacher_v1.last_name'
        />
        <MandarkTable.Column
          heading='Requested'
          className='manage-staff__date'
          content={(staff) =>
            staff.has('teacher') ? renderMoment(staff.getInsertedAt(), 'dateFormal') : null
          }
          sortBy='inserted_at'
        />
        <MandarkTable.Column
          heading='Permission'
          content={(staff) =>
            staff.has('teacher') ? capitalize(staff.getRole()?.get('title')) : 'Teacher'
          }
          sortBy='role_v1.title'
        />
        <MandarkTable.Column
          content={(staff) => {
            return (
              <div>
                {staff.getTeacher().size !== 0 ? (
                  <Button
                    color='destructive'
                    size='s'
                    variant='text'
                    onClick={() => {
                      setStaffMemberToReject(staff);
                    }}
                  >
                    <Icon icon={['far', 'xmark']} className='u-mar-r_1' />
                    Reject
                  </Button>
                ) : (
                  <Button
                    color='destructive'
                    size='s'
                    variant='text'
                    onClick={() => {
                      rejectUser({
                        staff,
                        schoolId: params.schoolId
                      });
                    }}
                  >
                    <Icon icon={['far', 'xmark']} className='u-mar-r_1' />
                    Reject
                  </Button>
                )}
              </div>
            );
          }}
          align='right'
        />
      </MandarkTable>
      {staffMemberToReject && (
        <RejectUserModal
          setStaffMemberToReject={setStaffMemberToReject}
          staffMemberToReject={staffMemberToReject}
          params={params}
        />
      )}
    </div>
  );
};

Approved.propTypes = {
  params: PropTypes.object
};

export default Approved;
